import { GeneralModel } from "./general.model";

export class Formula extends GeneralModel {
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/formula.model.ts